<ng-container *ngIf="data">
    <div class="bg-white shadow custom-dialog-container" [ngStyle]="{'width': this.size[0], 'height': this.size[1]}">
        <!-- Header -->
        <div class="border-b border-b-gray-300 zuper-dialog-header" *ngIf="!data.hide_header"
            [ngStyle]="{'width': this.size[0]}">
            <div class="flex items-center space-x-2">
                <h6 mat-dialog-title class="font-semibold primary-font">{{data.title}}</h6>
            </div>
            <div class="flex items-center ml-auto">
                <button (click)="closeDialog('close')"
                    class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
                    <em class="ti ti-x text-xl font-bold"></em>
                </button>
            </div>
        </div>
        <!-- Body -->
        <div class="overflow-y-scroll flexible-container">
            <ng-container [ngSwitch]="data.dataType">
                <ng-container *ngSwitchCase="'DETAILS'">
                    <dl class="grid grid-cols-3 gap-3 zuper-dialog-body">
                        <ng-container *ngFor="let item of data.data">
                            <ng-container *ngTemplateOutlet="customData; context:{
                                    data: item
                                }"></ng-container>
                        </ng-container>
                    </dl>
                </ng-container>
                <ng-container *ngSwitchCase="'IFRAME'">
                    <iframe #sdkDialogFrame id="sdk-custom-dialog-frame" title="sdk-custom-dialog-frame"
                        class="sdk-iframe-container"
                        *ngIf="sdkDataIframeUrl"
                        [src]="sdkDataIframeUrl"
                        (load)="onIframeLoad($event)"></iframe>
                </ng-container>
                <ng-container *ngSwitchCase="'HTML'">
                    <div [ngStyle]="{
                        'width': this.size[0],
                        'height': this.size[1]
                    }" [innerHTML]="data.html | safeHtml: false"></div>
                </ng-container>
                <ng-container *ngSwitchCase="'FORM'">
                    <div class="form-builder-container">
                    <app-form-builder [formElements]="formConfig.fields" [checklistFormGroup]="formGroup"
                        (checklistValues)="onFormSubmit($event)" (checklistChanges)="onFormChange($event)"
                        [submitFormDisplayKey]="data.actions.confirm.label"
                        [cancelFormDisplayKey]="data.actions.cancel.label"
                        [patchFormValues]="formValues"
                        ></app-form-builder>
                    </div>
                </ng-container>
            </ng-container>
        </div>

        <!-- Footer -->
        <div mat-dialog-actions class="flex justify-end zuper-dialog-footer border-t border-gray-300"
            *ngIf="!data.hide_footer && data.dataType !== 'FORM'">
            <!-- hide entire footer if both button hide is true -->
            <div class="flex justify-around space-x-3">
                <button type="button" (click)="closeDialog('cancel')" *ngIf="!data.actions.cancel.hide"
                    class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
                    [ngClass]="data.actions.cancel.className">
                    {{data.actions.cancel.label || 'cancel.text' | translate}}
                </button>
                <button
                    class="btn-small bg-primary px-6 items-center py-2 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none"
                    (click)="closeDialog('confirm')" [ngClass]="data.actions.confirm.className"
                    *ngIf="!data.actions.confirm.hide" type="submit">
                    {{data.actions.confirm.label || 'confirm.text' | translate}}
                </button>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #customData let-data="data">
    <dl [ngClass]="data.width" class="my-3">
        <dt class="font-medium leading-6 text-gray-900 text-base">
            {{data.label}}
        </dt>
        <ng-container [ngSwitch]="data.type">
            <ng-container *ngSwitchCase="'FILE'">
                <dd class="mt-1 leading-6 text-gray-700 sm:mt-2"><a target="_blank" class="text-info"
                        href="{{data.value}}"> {{'text.open_link' | translate}}
                        <em class="ti ti-file text-info text-xl mx-2 my-1"></em>
                    </a>
                </dd>
            </ng-container>
            <ng-container *ngSwitchCase="'MULTIFILE'">
                <dd class="mt-1 leading-6 text-gray-700 sm:mt-2" *ngFor="let item of data.value; let i = index">
                    <a target="_blank" class="text-info" href="{{item}}">{{('text.open_link' | translate) + ' ' + (i +
                        1)}}
                        <em class="ti ti-file text-info text-xl mx-2 my-1"></em>
                    </a>
                </dd>

            </ng-container>
            <ng-container *ngSwitchCase="'TIME'">
                <dd class="mt-1 leading-6 text-gray-700 sm:mt-2 ng-star-inserted">
                    {{data.value | timeformat }}
                </dd>
            </ng-container>
            <ng-container *ngSwitchCase="'DATE'">
                <dd class="mt-1 leading-6 text-gray-700 sm:mt-2 ng-star-inserted">
                    {{data.value | dateformat }}
                </dd>
            </ng-container>
            <ng-container *ngSwitchCase="'DATETIME'">
                <dd class="mt-1 leading-6 text-gray-700 sm:mt-2 ng-star-inserted">
                    {{data.value | datetime: dateTimeFormat: timezone }}
                </dd>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <dd class="mt-1 leading-6 text-gray-700 sm:mt-2 ng-star-inserted">
                    {{data.value}}
                </dd>
            </ng-container>

        </ng-container>
    </dl>
</ng-template>